/**
 * Custom Checkbox Component
 * Extends Ant Design Checkbox with custom styling
 */

import { Checkbox as AntCheckbox, CheckboxProps } from 'antd';
import classNames from 'classnames';
import './CustomCheckbox.scss';

export interface CustomCheckboxProps extends CheckboxProps {
  /** Checkbox variant */
  variant?: 'default' | 'card';
}

/**
 * CustomCheckbox Component
 */
const CustomCheckboxComponent: React.FC<CustomCheckboxProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const checkboxClasses = classNames('custom-checkbox', `custom-checkbox--${variant}`, className);

  return <AntCheckbox {...rest} className={checkboxClasses} />;
};

/**
 * CustomCheckboxGroup Component
 */
export const CustomCheckboxGroup = AntCheckbox.Group;

// Attach Group to CustomCheckbox for convenience
export const CustomCheckbox = Object.assign(CustomCheckboxComponent, {
  Group: AntCheckbox.Group,
});

export default CustomCheckbox;

